/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolPermissions200,
  GetApiV1AccesscontrolPermissions401,
  GetApiV1AccesscontrolPermissions500,
  GetApiV1AccesscontrolPermissionsQueryResponse,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissions.ts";
import { userControllerPermissionViewModelSchema } from "../userControllerPermissionViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolPermissions200Schema = z.array(
  z.lazy(() => userControllerPermissionViewModelSchema),
) as unknown as ToZod<GetApiV1AccesscontrolPermissions200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolPermissions401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissions401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolPermissions500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolPermissions500>;

export const getApiV1AccesscontrolPermissionsQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolPermissions200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolPermissionsQueryResponse>;
